export default {
  TIME: 'time',
  RISK: 'risk',
  COST: 'cost'
};
